import React, { useState } from "react";
import "./tabs.scss";
import {
  getStateLocalStorage,
  getTempStateLocalStorage,
  setTempStateLocalStorage,
} from "../local-store";
import { motion } from "framer-motion";
import { isNil } from "lodash";

function Tabs({ items = [], initialOpenIndex, id, height, childrenHeight }) {
  const [selected, setSelected] = useState(
    items.length > 0
      ? id && !isNil(getTempStateLocalStorage(id))
        ? getTempStateLocalStorage(id)
        : initialOpenIndex ?? 0
      : null,
  );

  return (
    items.length > 0 && (
      <div
        className={`grigora-ui-kit-tabs select-none ${
          selected ? `selected__${items[selected].key}` : ""
        }`}
        style={{ height }}
      >
        <div className="grigora-ui-kit-tabs__titles flex w-full px-5 overflow-x-auto grigora-hidden-scrollbar">
          {items.map((e, index) => {
            return (
              <div
                className={`relative flex flex-1 max-w-[33%] gap-1 px-3 py-4 pb-3 duration-200 items-center justify-center text-grigora-base select-none cursor-pointer rounded-t-[21px]`}
                onClick={() => {
                  setSelected(index);
                  if (id) {
                    var data = index;
                    setTempStateLocalStorage(id, data);
                  }
                }}
                key={`grigora-tabs-${id}-title-${index}`}
                style={{
                  color: selected === index ? "var(--color-ui-blue)" : "#000",
                }}
              >
                <div className="relative z-10 gap-[2px] flex flex-col">
                  {e.icon && (
                    <div className="grigora-ui-kit-tabs__icon">
                      {React.createElement(e.icon, {
                        className: "w-5 h-5 mx-auto",
                      })}
                    </div>
                  )}
                  {e.label}
                </div>
                {selected === index && (
                  <motion.div
                    layoutId={`grigora-tabs-${id ?? "-"}`}
                    className="grigora-ui-kit-tabs__bg-layer w-full absolute z-0 bottom-0 left-0 top-0 right-0"
                  ></motion.div>
                )}
                {/* <div
                    style={{
                      opacity: e.isUpdated ? 1 : 0,
                    }}
                    className="w-[6px] h-[6px] rounded-full bg-blue-500"
                  ></div> */}
              </div>
            );
          })}
        </div>
        <div
          className="grigora-ui-kit-tabs__children"
          style={{ height: childrenHeight }}
        >
          <>{items[selected].children ? items[selected].children : null}</>
        </div>
      </div>
    )
  );
}

export default Tabs;
